<form [formGroup]="dateForm" *ngIf="dateOfBirthMask && dateOfBirthMask.fieldOrder">
    <div class="d-flex align-items-center input_field main-date-birth p-0">
        <ng-container *ngFor="let field of dateOfBirthMask.fieldOrder; let i = index">
            <!-- <label>{{ field.key | titlecase }}:</label> -->
            <div class="d-flex align-items-center hw-56" 
                [ngStyle]="{'width': (i != (dateOfBirthMask.fieldOrder.length - 1)) ? '60px' : '','min-width': (i != (dateOfBirthMask.fieldOrder.length - 1)) ? '55px' : '' }"
                [ngClass]="{'flex-fill': i === (dateOfBirthMask.fieldOrder.length - 1), addClass}">

                <input (keydown)="disableKeyDown($event)" #inputElement type="text" class="input_field m-0 border-0 w-100 custom-date-input" [id]="'dob_' + i" (input)="onDateInput($event, i)" [formControlName]="field.key" [placeholder]="field.placeholder"  
                    (keydown.backspace)="handleBackspace($event, i)" [ngStyle]="getInputStyle(i)"/>
                <span *ngIf="i != (dateOfBirthMask.fieldOrder.length - 1)">
                    {{dateOfBirthMask.specialCharacters[0]}}
                </span>
            </div>
            <p style="bottom: -30px;" [ngClass]="{'pb-2': css_custom_class }" class="mat-error text-danger w-100 d-block mb-0 fs-12 position-absolute"
              *ngIf="dateForm.controls[field.key].touched && dateForm.controls[field.key].invalid">
              {{type === _shared.customDateInputType.DOB ? 'Please enter valid date of birth' : 'Please enter valid Debt duration'}}
            </p>
        </ng-container>
    </div>
</form>
<p *ngIf="error" class="mat-error text-danger w-100 d-block mb-0 fs-12">Please enter validd date </p>